import styled from 'styled-components';

export const StyledEnvironmentInfo = styled.div`
  display: flex;
  flex-direction: column;
  color: var(--color-text-main);
  width: 350px;
  padding: 15px;
  box-shadow: 0px 0px 6px 0px #00000026;
  border-radius: 5px;
  background-color: #ffffff;

  .component-title {
    font-size: 16px;
    font-weight: 600;
    color: #2f2f35;
    margin-bottom: 5px;
  }

  .component-body {
    display: flex;
    flex-direction: row;
    gap: 10px;
  }

  .left-area {
    flex: 1 0;
  }

  .left-area .weather {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 500;
    color: #585959;
    gap: 10px;
  }

  .right-area {
    flex: 1 0;
  }

  .right-area .date-time {
    display: flex;
    flex-direction: column;
    height: 36px;
  }

  .right-area .date {
    font-size: 12px;
    font-weight: 600;
    text-wrap: nowrap;
    color: #585959;
  }

  .right-area .time {
    font-size: 10px;
    font-weight: 400;
    color: #2f2f35;
  }

  .item {
    display: flex;
    margin-top: 7px;
  }

  .item .label {
    font-size: 12px;
    font-weight: 500;
    color: #2f2f35;
    width: 70px;
  }

  .item .value {
    font-size: 12px;
    font-weight: 400;
    color: #585959;
    display: flex;
    align-items: center;
  }

  .item .value.point .main-value {
    font-size: 12px;
    font-weight: 400;
  }

  .item .value.point .sub-value {
    font-size: 8px;
    font-weight: 400;
    margin-bottom: 1px;
    letter-spacing: -0.3px;
  }

  .item .value.purple .main-value,
  .item .value.purple .sub-value {
    color: #660099 !important;
  }

  .item .value.red .main-value,
  .item .value.red .sub-value {
    color: #7e0023 !important;
  }

  .bottom-line {
    padding-bottom: 7px;
    border-bottom: 1px solid #dadada;
  }
`;
